import ks from "@shared/kalmstromShared4";
import "../css/styles.css";
import "prismjs";
import "prismjs/components/prism-powershell";
import "prismjs/components/prism-json";
import "prismjs/plugins/line-numbers/prism-line-numbers";
import "prismjs/plugins/line-numbers/prism-line-numbers.css";
import "prismjs/themes/prism.css";

import DBState from "./DBState";
import DBModalManager from "./DBModalManager";
import DBListManager from "./DBListManager";
import DBEventRouter from "./DBEventRouter";
import DBDragDrop from "./DBDragDrop";
import DBCanvas from "./DBCanvas";

export default class DBMain {

    public static DBBegin = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            ks.kApplication.version = "1.0.0";
            DBMain.WireCallbacks();
            DBDragDrop.Setup();
            DBEventRouter.SetupAll();
            DBState.SaveState();
            DBState.LoadFromStorage();
        } catch (e) {
            ks.kGlobalErrorHandler(e, "DBMain.DBBegin");
        }
    };

    private static WireCallbacks = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            DBState.OnRenderLists = DBListManager.RenderLists;
            DBState.OnShowToast = DBModalManager.ShowToast;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "DBMain.WireCallbacks");
        }
    };
}

const OnWindowLoad = (): void => {
    DBMain.DBBegin();
};

window.addEventListener("load", OnWindowLoad);
